import { memo } from 'react';

import Debug from '@/components/Debug';
import { ScheduleExpectation } from '@/types/scheduleExpectation';
import { Card } from '@/ui';
import { cn } from '@/ui/lib/utils';
import { formatShortDate } from '@/utils/dates';

import ExpectationDetailsAccordion from './ExpectationDetailsAccordion';

interface Props {
  expectation: ScheduleExpectation;
  isActive?: boolean;
  isSequence?: boolean;
}

const ScheduleExpectationDetails = ({
  expectation,
  isActive = false,
  isSequence = false
}: Props) => {
  const { description, start_at, custom_schedule_expectation_id } = expectation;
  const isCustomExpectation = !!custom_schedule_expectation_id;

  return (
    <Card
      data-testid={isActive ? 'active-expectation-detail' : undefined}
      className={cn(
        'bg-uniform-gray-50 dark:bg-uniform-gray-800',
        isActive && 'ring-2 ring-blue-400'
      )}
      padding="sm">
      {isSequence && start_at && (
        <div className="font-semibold text-sm mb-1 text-uniform-gray-600 dark:text-uniform-gray-400">
          Start Date: {formatShortDate(start_at)}
        </div>
      )}
      <p className="text-sm">{description}</p>

      {isCustomExpectation && (
        <ExpectationDetailsAccordion
          note={expectation.note}
          createdBy={expectation.created_by}
          createdAt={expectation.created_at}
        />
      )}

      <Debug object={expectation} />
    </Card>
  );
};

export default memo(ScheduleExpectationDetails);
